import axios from 'axios';
import { getTenantCode } from '../Utils/tenantUtils';
import { AUTH_DATA, LS_KEY_AUTH_DATA } from '../constant/constants';

const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
const apiUrl = `${baseUrl.split('api/')[0]}api/v2/refresh-token`;

export default async function refreshAccessToken() {
  try {
    const tenantCode = getTenantCode();
    const response = await axios.post(
      apiUrl,
      {},
      {
        headers: {
          'X-Tenant-Code': tenantCode
        },
        withCredentials: true
      }
    );

    const accessToken = response.data.access_token;

    const updatedAuthData = {
      ...AUTH_DATA,
      token_id: accessToken,
      access_token: accessToken
    };
    localStorage.setItem(LS_KEY_AUTH_DATA, JSON.stringify(updatedAuthData));

    return accessToken;
  } catch (error) {
    console.error('Refresh token failed:', error);
    localStorage.removeItem(LS_KEY_AUTH_DATA);
    throw error;
  }
}
